import React from "react";
import { List, Datagrid, TextField, DateField, EmailField } from "react-admin";

export const NewsletterSendLogList = () => (
  <List>
    <Datagrid>
      <TextField source="campaign" />
      <EmailField source="subscriber_email" />
      <TextField source="status" />
      <TextField source="error" />
      <DateField source="sent_at" showTime />
      <DateField source="created_at" showTime />
    </Datagrid>
  </List>
);
